/** @format */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxFudisModule, PaginationComponent } from '@funidata/ngx-fudis';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';
import { SisCommonModule } from 'sis-common';
import { CommonSearchModule, SisComponentsModule } from 'sis-components';
import { SearchCooperationNetworkResultRowComponent } from './search-cooperation-network-result-row/search-cooperation-network-result-row.component';
import { SearchCooperationNetworkComponent } from './search-cooperation-network/search-cooperation-network.component';
import { SearchFilterAssessmentItemTypeComponent } from './search-filters/search-filter-assessment-item-type/search-filter-assessment-item-type.component';
import { SearchMainComponent } from './search-main/search-main.component';
import { SearchOpenUniversityComponent } from './search-open-university/search-open-university.component';
import { SearchResultRowComponent } from './search-result-row/search-result-row.component';
import { SearchTabsComponent } from './search-tabs/search-tabs.component';
import { searchStates } from './search.route';

@NgModule({
    declarations: [
        SearchMainComponent,
        SearchResultRowComponent,
        SearchCooperationNetworkComponent,
        SearchTabsComponent,
        SearchOpenUniversityComponent,
        SearchCooperationNetworkResultRowComponent,
        SearchFilterAssessmentItemTypeComponent,
    ],
    imports: [
        BrowserModule,
        CommonSearchModule,
        UIRouterModule.forChild({ states: searchStates }),
        SisCommonModule,
        SisComponentsModule,
        TranslateModule.forChild(),
        NgxFudisModule,
        PaginationComponent,
    ],
})
export class SearchModule {}
